// enrolledCourseDetailsReducer.js
import {
  FETCH_ENROLLED_COURSE_DETAILS_FAILURE,
  FETCH_ENROLLED_COURSE_DETAILS_REQUEST,
  FETCH_ENROLLED_COURSE_DETAILS_SUCCESS,
} from "../Actions/types";

const initialState = {
  loading: false,
  courseDetails: {}, // Ensure courseDetails is defined
  error: null,
};

const enrolledCourseDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENROLLED_COURSE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ENROLLED_COURSE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        courseDetails: action.payload, // Set courseDetails from payload
        error: null,
      };
    case FETCH_ENROLLED_COURSE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        courseDetails: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default enrolledCourseDetailsReducer;
